<template>
    <div class="rsv_search_filter" v-clickoutside:action_ClickOutside="{}"
        @keydown.up.prevent="action_KeyUp" 
        @keydown.down.prevent="action_KeyDown"
        @keydown.page-up.prevent="action_KeyPageUp"
        @keydown.page-down.prevent="action_KeyPageDown"
        @keydown.esc="action_ESC"
        @click="action_Click"
    >
        <HServiceSearchInput ref="search_input"
            :isShow="isInputShow"
            @setSearchKeyword="setSearchKeyword"
            @setSearchResults="setSearchResults"
        />
        <HServiceSearchResult
            :results="searchResults"
            :focusedService="focusedService"
            :keyword="searchKeyword"
            :isShowRegistHService="isShowRegistHService"
            :fromSheet="fromSheet"
            @setSelectedService="setSelectedService"
            @setIsShowRegistHService="setIsShowRegistHService"
        />
    </div>
</template>


<script>
import HServiceSearchInput from './HServiceSearchInput/HServiceSearchInput.vue'
import HServiceSearchResult from './HServiceSearchResult/HServiceSearchResult.vue'

import { showReservationInfoPopup, showUserInfoPopup } from '../../../sheet-overlays'
import { exitTimeSelectMode, reservationSelection } from '../../../reservation-selection'

export default {
    components: { HServiceSearchInput, HServiceSearchResult },
    props: {
        fromSheet: Boolean
    },
    data() {
        return {
            searchKeyword: undefined,
            searchResults: undefined,
            focusIndex: undefined,

            isShowRegistHService: false,
        }
    },
    computed: {
        isInputShow: function() {
            if (this.fromSheet == false) { return true }
            return this.isShowRegistHService == false
        },
        resultLength: function() {
            if (this.searchResults == undefined) { return 0 }
            return this.searchResults?.length
        },
        reservationOnlyObject: function() {
            return {
                isUnregisteredUser: true,
                isNewHService: false,
                name: this.searchKeyword
            }
        },
        newHServiceObject: function() {
            return {
                isUnregisteredUser: false,
                isNewHService: true,
                name: this.searchKeyword
            }
        },

        focusedService: function() {
            if (this.searchResults == undefined || this.resultLength == 0) { return undefined }
            if (this.focusIndex <= this.resultLength) { return this.searchResults[this.focusIndex] }
            else if (this.focusIndex == this.resultLength) { return this.reservationOnlyObject }
            return this.newHServiceObject
        }
    },
    methods: {
        // MARK: - Setters
        setSearchKeyword(keyword) {
            this.searchKeyword = keyword
        },
        setSearchResults(results) {
            this.searchResults = results
            if (results != undefined) {
                results.push(this.reservationOnlyObject)
                results.push(this.newHServiceObject)
            }
            this.focusIndex = -1
        },
        setSelectedService(service) {
            reservationSelection.selectedHService = service
            this.setSearchResults(undefined)
            this.$refs.search_input.clearKeyword()

            // Show Popup
            if (this.fromSheet == true) {
                showReservationInfoPopup()
            }
            else {
                showUserInfoPopup()
            }
        },

        // MARK: - Regist
        setIsShowRegistHService(isShowRegistHService) {
            this.isShowRegistHService = isShowRegistHService
        },

        // MARK: - Actions
        action_Click() {
            exitTimeSelectMode()
        },
        action_KeyUp(_, count = 1) {
            if (this.focusIndex == undefined) { return }
            this.focusIndex -= count
            if (this.focusIndex < 0) { this.focusIndex = 0 }
        },
        action_KeyDown(_, count = 1) {
            if (this.searchResults == undefined || this.searchResults.length == 0) { return }
            if (this.focusIndex == undefined) { this.focusIndex = 0 }
            else {
                this.focusIndex += count
            }
            if (this.focusIndex >= this.searchResults.length - 1) {
                this.focusIndex = this.searchResults.length - 1
            }
        },
        action_KeyHome() {
            this.focusIndex = 0
        },
        action_KeyEnd() {
            this.focusIndex = this.resultLength - 1
        },
        action_KeyPageUp(e) {
            this.action_KeyUp(e, 5)
        },
        action_KeyPageDown(e) {
            this.action_KeyDown(e, 5)
        },
        action_ESC() {
            this.setSearchResults(undefined)
        },
        action_ClickOutside() {
            if (this.isShowRegistHService == true) { return }
            this.setSearchResults(undefined)
        }
    }
}
</script>